import { SearchFilterComparisonOperator } from "./types";

export function parseComparisonOperator(
  comparisonOperator: SearchFilterComparisonOperator,
) {
  switch (comparisonOperator) {
    case SearchFilterComparisonOperator.EQUALS:
      return "=";
    case SearchFilterComparisonOperator.LESS:
      return "<";
    case SearchFilterComparisonOperator.GREATER:
      return ">";
    default:
      throw new Error("Invalid comparison operator");
  }
}
